<template>
  <div class="data-card">
    <div class="title flex-center">
      数据 
      <span class="detail-link flex-center" v-if="sportType === '篮球'" @click="goDetail">
        查看明细 
        <van-icon name="arrow" class="icon" size="16px" />
      </span>
    </div>
    <!-- 足球 -->
    <football-data
      v-if="sportType === '足球'"
      :game-event="gameEvent"
      :home-team-id="homeTeamId"
      :away-team-id="awayTeamId"
    />
    <!-- 篮球 -->
    <basketball-data
      v-if="sportType === '篮球'"
      :technical-data="basketballTechnicalData"
      :home-team-name="homeTeamName"
      :away-team-name="awayTeamName"
      :home-team-icon="homeTeamIcon"
      :away-team-icon="awayTeamIcon"
      :home-score="homeScore"
      :away-score="awayScore"
    />
  </div>
</template>

<script>
import FootballData from './footballData.vue'
import BasketballData from './basketballData.vue'
export default {
  components: {
    FootballData,
    BasketballData
  },
  props: {
    gameEvent: {
      type: Array,
      default: () => []
    },
    homeTeamId: {
      type: [String, Number],
      default: ''
    },
    awayTeamId: {
      type: [String, Number],
      default: ''
    },
    sportType: {
      type: String,
      default: ''
    },
    basketballTechnicalData: {
      type: Array,
      default: () => []
    },
    homeTeamName: {
      type: String,
      default: ''
    },
    awayTeamName: {
      type: String,
      default: ''
    },
    homeTeamIcon: {
      type: String,
      default: ''
    },
    awayTeamIcon: {
      type: String,
      default: ''
    },
    homeScore: {
      type: [Number, String],
      default: null
    },
    awayScore: {
      type: [Number, String],
      default: null
    },
    gameId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {

    };
  },
  methods: {
    goDetail() {
      const id = this.gameId
      if (id == null || id === '') return
      this.$router.push({
        name: 'NewGameDetailBasketballPlayerStats',
        params: { gameId: String(id) },
      })
    }
  },
};
</script>

<style scoped lang="scss">
.data-card {
  padding: 12px 16px;
  background: #fff;
  margin-top: 12px;
  .title {
    font-size: 15px;
    font-weight: bold;
    color: #3D3D3D;
    margin-bottom: 12px;
  }
  .detail-link{
    font-size: 14px;
    color: #B1B3B8;
    font-weight: 400;
    .icon{
      font-weight: 600;
      margin-left: 4px;
    }
  }
}
</style>
